import React from 'react';
import { Reveal } from './Reveal';
import { testimonialScreenshots } from '../data/content';
export function Testimonials() {
  return <section id="testimonios" className="w-full scroll-mt-16 bg-forest py-16 sm:py-20" data-id="element-161" data-mp="3kqw54mwtl6h6">
      <div className="mx-auto max-w-5xl px-5 sm:px-6" data-id="element-162" data-mp="3fycqdmmec5as">
        <Reveal className="text-center" data-id="element-163" data-mp="3b0krg8nc3ix3">
          

          <h2 className="mt-4 text-[24px] font-bold tracking-tight text-white sm:text-[28px]" data-id="element-164" data-mp="3b01fr9oa1qri">
            Lo Que Dicen Quienes Ya Lo Vivieron
          </h2>
          <p className="mt-2 text-[15px] text-gold" data-id="element-165" data-mp="31zd3okig20h9">
            Es Tiempo de que lo vivas TU MISMO
          </p>
        </Reveal>

        <ul className="mt-10 grid gap-6 sm:grid-cols-2" data-id="element-166" data-mp="2x1l18wk6avyt">
          {testimonialScreenshots.map((item, i) => <Reveal as="li" key={item.image} delay={i * 0.08} className="h-full" data-id="element-167" data-mp="2s308fi793eke" data-mpi={i}>
              <figure className="h-full overflow-hidden rounded-xl bg-white shadow-lg" data-id="element-168" data-mp="v9omle2pl5zt">
                <img src={item.image} alt={item.alt} className="w-full object-contain" loading="lazy" data-id="element-169" data-mp="q9tvpaixoger" />
              </figure>
            </Reveal>)}
        </ul>

        <Reveal delay={0.08} data-id="element-170" data-mp="h814jfcje0g9">
          <p className="mx-auto mt-8 max-w-xl text-center text-xs leading-relaxed text-white/50" data-id="element-171" data-mp="m5kjyikz0j9s">
            Nombres y números ocultos para proteger la privacidad de cada persona. Los resultados
            individuales pueden variar.
          </p>
        </Reveal>
      </div>
    </section>;
}